module.exports = __webpack_public_path__ + "static/media/memories.d5188657.png";